const VIDEO = {
    BANANAS_THE_MOVIE: "https://www.youtube.com/embed/8W0qs8pDu64", // Bananas - THE MOVIE
    HALLOWEEN_SONG: "https://www.youtube.com/embed/JOpgu_3O0WM", // Halloween Song
    ORANGUTAN_ARITHMETIC:
        "https://www.youtube.com/embed/qmU3xp9R0nM?si=jxLtEijSbf7XtrUs",
    STEVE_JOSEPH_CURTIS_2019: "https://www.youtube.com/embed/ekyh20VfSoY", // Steve, Joseph and Curtis, 12/27/2019
    STEVE_JOSEPH_CURTIS_2022: "https://www.youtube.com/embed/ug_QohiXuKM", // Steve, Joseph & Curtis Yungen - August 7, 2022
    UKULELE_JIMMY: "https://www.youtube.com/embed/Fz4RAyHUSVE", // Break Out Your Ukulele, Jimmy!
    WE_SHARE_THE_SAME_SKY:
        "https://www.youtube.com/embed/ftvl2ReR7rQ?si=G3vvXO6cLEziveMx", // NPR Tiny Desk Submission, We Share the Same Sky
};

export default VIDEO;
